import { createStore as reduxCreateStore } from "redux";
import { sortCards } from '../data/sortCards';

const reducer = (state, action) => {
  if (action.type === `PREV_COMMENT`) {
    return Object.assign({}, state, {
      currentComment: Math.max(state.currentComment - 1, 0 ),
    })
  } else if ( action.type === `NEXT_COMMENT` ) {
    return Object.assign({}, state, {
      currentComment: Math.min(state.currentComment + 1, 7 ),
    })
  }  else if ( action.type === `SHOW_COMMENTS` ) {
    return Object.assign({}, state, {
      showComments: true,
    })
  }  if ( action.type === `HIDE_COMMENTS` ) {
    return Object.assign({}, state, {
      showComments: false,
    })
  } else if ( action.type === `INCREMENT_MESSAGE` ) {
    return Object.assign({}, state, {
      currentMessage: Math.min(state.currentMessage + 1, 5 ),
    })
  }  else if ( action.type === `TOGGLE_MESSAGE` ) {
    return Object.assign({}, state, {
      showMessage: !state.showMessage,
    })
  }  else if ( action.type === `SHOW_MESSAGE` ) {
    return Object.assign({}, state, {
      showMessage: true,
    })
  }  else if ( action.type === `SET_LIST_ONE` ) {
    return Object.assign({}, state, {
      listOne: action.listOne,
    })
  }  else if ( action.type === `SET_LIST_TWO` ) {
    return Object.assign({}, state, {
      listTwo: action.listTwo,
    })
  }
  return state
};

const initialState = {
  currentComment: 0,
  currentMessage: 0,
  showMessage: true,
  listOne: [],
  listTwo: sortCards,
  showComments: false
};

let createStore = () => reduxCreateStore(
  reducer,
  initialState
);

if (typeof window !== `undefined`) {
  createStore = () => reduxCreateStore(
    reducer,
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true })
  );
}

export default createStore;
